import watchAuthentication from './watchAuthentication';

export default function* authenticationFlow() {
  yield* watchAuthentication();
}
